import { render } from "./highlighted-features-introduction-modal.vue?vue&type=template&id=3e346274&ts=true"
import script from "./highlighted-features-introduction-modal.ts?vue&type=script&lang=ts&external"
export * from "./highlighted-features-introduction-modal.ts?vue&type=script&lang=ts&external"

import "./highlighted-features-introduction-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__